
export default function AchievementsSection() {
  const achievements = [
    {
      year: '2024',
      title: 'Sustainable Tourism Award',
      description: 'Recognized by the Global Sustainable Tourism Council for environmental leadership in outdoor hospitality.'
    },
    {
      year: '2023',
      title: 'Best Glamping Developer',
      description: 'Named "Developer of the Year" by Glamping Business Magazine for innovative design and guest satisfaction.'
    },
    {
      year: '2022',
      title: '$50M Investment Milestone',
      description: 'Successfully raised and deployed over $50 million in glamping development projects across North America.'
    },
    {
      year: '2021',
      title: 'Carbon Neutral Certification',
      description: 'Achieved carbon neutral operations across all properties through renewable energy and offset programs.'
    },
    {
      year: '2020',
      title: 'COVID-19 Safety Excellence',
      description: 'Pioneered industry-leading health and safety protocols, maintaining 100% guest satisfaction during pandemic.'
    },
    {
      year: '2019',
      title: 'Community Impact Award',
      description: 'Honored for creating over 200 local jobs and contributing $5M annually to rural economies.'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Achievements & Recognition</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our commitment to excellence has been recognized by industry leaders and sustainability organizations
          </p>
        </div>
        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-emerald-200"></div>
          <div className="space-y-8">
            {achievements.map((achievement, index) => (
              <div key={index} className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                <div className={`w-1/2 ${index % 2 === 0 ? 'pr-8 text-right' : 'pl-8 text-left'}`}>
                  <div className="bg-white p-6 rounded-lg shadow-md">
                    <div className="text-emerald-600 font-bold text-lg mb-2">{achievement.year}</div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{achievement.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{achievement.description}</p>
                  </div>
                </div>
                <div className="relative z-10">
                  <div className="w-4 h-4 bg-emerald-600 rounded-full border-4 border-white shadow-md"></div>
                </div>
                <div className="w-1/2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
